import * as React from "react";
import {FormBodyProps} from "../../common/props/FormBodyProps";
import SectionView from "../../layout/section/SectionView";
import Row from "../../layout/Row";
import Col from "../../layout/Col";
import QuoteForm from "./QuoteForm";
import QuoteItemFormGroup from "../quoteItemsPicker/QuoteItemFormGroup";
import LabourItemFormGroup from "../lobourItemsPicker/LabourItemFormGroup";
import LeadAppointmentPicker from "../../lead/v4/appointment/LeadAppointmentPicker";
import InputFormGroup from "../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import PriceStrategyFormGroup from "../priceStrategyPicker/PriceStrategyFormGroup";
import {api} from "../../../api/api";
import {toKeyIndexedObject} from "../../../utils/ArrayUtils";
import QuoteItem from "../../../model/quote/QuoteItem";
import {option} from "ts-option";
import {RequiredFormField} from "../../../validation/FormField";
import {getPartnerBrand} from "../../../store/view/partnerBrand";
import {getBrand} from "../../../store/view/brand";
import {store} from "../../../navigation/ReduxProvider";

interface ComponentProps {
	/**
	 * Custom parts markup
	 */
	bespokeItemMarkup: number
}

type Props = ComponentProps & FormBodyProps<QuoteForm>

export default class QuoteFormBody extends React.PureComponent<Props> {
	render() {
		return <SectionView customClass={"c-quote"}>
			<div>
				<Row>
					<Col xl={12} md={12}>
						<InputFormGroup label="Quote title"
										placeholder="Enter quote title"
										field={this.props.form.summary}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.summary)}/>
					</Col>
				</Row>
				<Row customClass={"reset-dropdown-right"}>
					<Col xl={6} md={6}>
						<FormGroup label={"Appointment (optional)"} error={this.props.form.appointmentId.firstError().orNull}>
							<LeadAppointmentPicker
								onChange={app => this.props.onFieldChange(
									this.props.form.appointmentId.updateValue(app.map(a => a.id))
								)}
								leadId={this.props.form.leadId.getValue()}
								selectedAppointmentId={this.props.form.appointmentId.getOptionalValue()}/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col xl={12} md={12}>
						<PriceStrategyFormGroup field={this.props.form.partsPriceStrategy}
												customClass={'c-quote-button-right'}
												onChange={this.changePriceStrategy}/>
					</Col>
				</Row>
				<Row customClass={"reset-dropdown-right"}>
					<Col xl={12} md={12}>
						<QuoteItemFormGroup label={""}
											form={this.props.form}
											onChange={this.props.onFieldChange}
											field={this.props.form.items}
											partsPriceStrategy={this.props.form.partsPriceStrategy.getValue()}
											vat={this.props.form.vat.getValue()}
											vatRegistered={this.props.form.vatRegistered.getValue()}
											partnerBrandId={this.props.form.partnerBrandId.getOptionalValue()}
											brandId={this.props.form.brandId.getValue()}
											bespokeItemMarkup={this.props.bespokeItemMarkup}/>
					</Col>
				</Row>
				<Row>
					<Col xl={12} md={12}>
						<LabourItemFormGroup label={""}
											 onChange={this.props.onFieldChange}
											 labourCost={this.props.form.labourCost.getValue()}
											 field={this.props.form.labourQuantity}/>
					</Col>
				</Row>
			</div>
		</SectionView>;
	}

	changePriceStrategy = (field: RequiredFormField<string>) => {
		if (this.props.form.partsPriceStrategy.getValue() != field.getValue()) {
			const oldAssets = this.props.form.items.getOptionalValue().getOrElse([]);
			const assetsIds = oldAssets.filter(qi => !qi.bespokeItem).map(qi => qi.assetId);
			if (assetsIds.length) {
				api.instance.assetApi.fetchAssetsByIds(assetsIds).then(assetSearch => {
					const state = store.getState();
					const brand = getBrand(this.props.form.brandId.getValue(), state);
					const priceAdjustmentFactor = getPartnerBrand(this.props.form.partnerBrandId.getOptionalValue().orNull, state)
						.map(pb => pb.priceAdjustmentFactor).getOrElse(0);
					const vat = brand.map(b => b.vatRate).getOrElse(0)
					const assets = assetSearch.map(a => a.increasePriceByPercentage(priceAdjustmentFactor)
						.increasePriceByPercentage(this.props.form.vatRegistered.getValue() ? 0 : vat))
					const assetMap = toKeyIndexedObject(assets, a => a.id);
					const items = oldAssets.map(asset => {
						if (assetMap[asset.assetId]) {
							return QuoteItem.fromAssetWithQuantity(assetMap[asset.assetId], asset.quantity,
								this.props.form.vat.getValue(), this.props.form.vatRegistered.getValue(), field.getValue())
						}
						return asset;
					});

					this.props.onFieldsChange([
						this.props.form.items.updateValue(option(items)),
						field
					]);
				})
			}
			else {
				this.props.onFieldChange(field);
			}
		}
	}
}
